import { render } from "./ReferralStatus.vue?vue&type=template&id=d87a1558"
import script from "./ReferralStatus.vue?vue&type=script&lang=js"
export * from "./ReferralStatus.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__